import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateReadOneActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    readDialerSessionSummary: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.CAMPAIGN_SESSION_SUMMARY, 'session'),
    readDialerSession: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.DIALER_CAMPAIGN_SESSION, 'session'),
    readTextCampaignSessionsSummary: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.TEXT_CAMPAIGN_SESSION_SUMMARY, 'text_session_summary')
}
